import React from 'react';
import { BuildingIcon, SearchIcon, UsersIcon, CpuIcon, CheckCircleIcon } from 'lucide-react';
export function PricingValue() {
  return <section className="py-24 bg-slate-50" data-id="element-6204">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6205">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6206">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-6207">
            Simple <span className="text-blue-600" data-id="element-6208">local business API</span>{' '}
            pricing
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-6209">
            Pay only for successful results. All accounts start with free
            credits to test before scaling.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-6210">
          {/* Search Card — Free, lead with this */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-6211">
            <div className="flex items-center gap-3 mb-4" data-id="element-6212">
              <SearchIcon className="w-5 h-5 text-slate-400" data-id="element-6213" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-6214">Search</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-6215">
              Find companies that match your filters
            </p>
            <div data-id="element-6216">
              <div className="flex items-baseline gap-2" data-id="element-6217">
                <span className="text-4xl font-bold text-slate-900" data-id="element-6218">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-6219">unlimited searches</p>
            </div>
          </div>

          {/* Find People Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-6220">
            <div className="flex items-center gap-3 mb-4" data-id="element-6221">
              <UsersIcon className="w-5 h-5 text-slate-400" data-id="element-6222" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-6223">Find people</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-6224">
              Find decision-makers with verified contact info
            </p>
            <div className="space-y-4" data-id="element-6225">
              <div data-id="element-6226">
                <div className="flex items-baseline gap-2" data-id="element-6227">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-6228">
                    from $3
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-6229">
                  per 100 contacts found
                </p>
              </div>
              <div className="grid grid-cols-3 gap-3 pt-4 border-t border-slate-100" data-id="element-6230">
                <div data-id="element-6231">
                  <div className="text-lg font-bold text-slate-900" data-id="element-6232">$3</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-6233">per 100 names</p>
                </div>
                <div data-id="element-6234">
                  <div className="text-lg font-bold text-slate-900" data-id="element-6235">$6</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-6236">per 100 emails</p>
                </div>
                <div data-id="element-6237">
                  <div className="text-lg font-bold text-slate-900" data-id="element-6238">$24</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-6239">per 100 phones</p>
                </div>
              </div>
            </div>
          </div>

          {/* Enrich Technographics Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-6240">
            <div className="flex items-center gap-3 mb-4" data-id="element-6241">
              <CpuIcon className="w-5 h-5 text-slate-400" data-id="element-6242" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-6243">
                Enrich technographics
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-6244">
              Get what technologies a company uses
            </p>
            <div data-id="element-6245">
              <div className="flex items-baseline gap-2" data-id="element-6246">
                <span className="text-4xl font-bold text-slate-900" data-id="element-6247">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-6248">
                per 100 records enriched
              </p>
            </div>
          </div>

          {/* Export Leads Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-6249">
            <div className="flex items-center gap-3 mb-4" data-id="element-6250">
              <BuildingIcon className="w-5 h-5 text-slate-400" data-id="element-6251" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-6252">Export leads</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-6253">
              Export enriched leads with employee count, hiring signals, and
              more
            </p>
            <div data-id="element-6254">
              <div className="flex items-baseline gap-2" data-id="element-6255">
                <span className="text-4xl font-bold text-slate-900" data-id="element-6256">$0.15</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-6257">
                per 100 records exported
              </p>
            </div>
          </div>
        </div>

        {/* Trust Signals */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-6258">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-6259">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-6260" />
            <span data-id="element-6261">Pay only for results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-6262">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-6263" />
            <span data-id="element-6264">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-6265">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-6266" />
            <span data-id="element-6267">Usage dashboard included</span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-6268">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-6269">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-6270">
              Try for free
            </a>
            <a href="https://api.openmart.ai/redoc" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-slate-700 font-medium bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors text-lg" data-id="element-6271">
              Read the docs
            </a>
          </div>
          <p className="text-sm text-slate-500 font-medium" data-id="element-6272">
            No credit card required
          </p>
        </div>
      </div>
    </section>;
}